module.exports = [
  {
    slug: "/usecases",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/DAIF_UseCase_In.mp4'),
    videoBgLoop: require('../assets/05_Usecases/DAIF_UseCase_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      // {
      //   url: "/usecases/1in",
      //   width: "24%",
      //   height: "4.5%",
      //   top: "74.6%",
      //   left: "72.4%",
      // },
      {
        url: "/usecases/2in",
        width: "24%",
        height: "4.5%",
        top: "79.2%",
        left: "72.4%",
      },
      {
        url: "/usecases/3in",
        width: "24%",
        height: "4.5%",
        top: "83.9%",
        left: "72.4%",
      },
      {
        url: "/usecases/4in",
        width: "24%",
        height: "4.5%",
        top: "88.5%",
        left: "72.4%",
      },
    ],
  },
  {
    slug: "/usecasesb",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/DAIF_UseCase_Loop.mp4'),
    videoBgLoop: require('../assets/05_Usecases/DAIF_UseCase_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      // {
      //   url: "/usecases/1in",
      //   width: "24%",
      //   height: "4.5%",
      //   top: "74.6%",
      //   left: "72.4%",
      // },
      {
        url: "/usecases/2in",
        width: "24%",
        height: "4.5%",
        top: "79.2%",
        left: "72.4%",
      },
      {
        url: "/usecases/3in",
        width: "24%",
        height: "4.5%",
        top: "83.9%",
        left: "72.4%",
      },
      {
        url: "/usecases/4in",
        width: "24%",
        height: "4.5%",
        top: "88.5%",
        left: "72.4%",
      },
    ],
  },

  // {
  //   slug: "/usecases/1in",
  //   bgImage: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
  //   videoTransitionIn: require('../assets/05_Usecases/DAIF_UseCase_Screen1_in.mp4'),
  //   videoTransitionInEnd: require('../assets/05_Usecases/DAIF_UseCase_Screen1_in-end.jpg'),
  //   videoBgLoop: "",
  //   bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen1_in-end.jpg'),
  //   ctas: [],
  //   autoNavigateURL: "/usecases/1",
  // },
  {
    slug: "/usecases/2in",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/DAIF_UseCase_Screen2_in.mp4'),
    videoTransitionInEnd: require('../assets/05_Usecases/DAIF_UseCase_Screen2_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen2_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/usecases/2",
  },
  {
    slug: "/usecases/3in",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/DAIF_UseCase_Screen3_in.mp4'),
    videoTransitionInEnd: require('../assets/05_Usecases/DAIF_UseCase_Screen3_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen3_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/usecases/3",
  },
  {
    slug: "/usecases/4in",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in.mp4'),
    videoTransitionInEnd: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/usecases/4",
  },

  // {
  //   slug: "/usecases/1",
  //   bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen1_in-end.jpg'),
  //   videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_01.mp4'),
  //   videoTransitionInEnd: require('../assets/05_Usecases/05_DAIF_UseCase_01_end.jpg'),
  //   videoBgLoop: "",
  //   bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
  //   ctas: [
  //     {
  //       url: "/",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "3.6%",
  //     },
  //     {
  //       url: "/usecasesb",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "7.4%",
  //     }
  //   ],
  // },
  {
    slug: "/usecases/2",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen2_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_02.mp4'),
    videoTransitionInEnd: require('../assets/05_Usecases/05_DAIF_UseCase_02_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/usecases/3",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen3_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_03.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_03_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/usecases/4",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_04_01.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_04_01_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/usecases/4/1",
        width: "17.3%",
        height: "12.5%",
        top: "54.8%",
        left: "45.8%",
      },
      {
        url: "/usecases/4/2",
        width: "17.3%",
        height: "12.5%",
        top: "68.8%",
        left: "45.8%",
      },
      {
        url: "/usecases/4/3",
        width: "17.3%",
        height: "12.5%",
        top: "54.8%",
        left: "64.2%",
      },
      {
        url: "/usecases/4/4",
        width: "17.3%",
        height: "12.5%",
        top: "68.8%",
        left: "64.2%",
      },
      {
        url: "/usecases/4/5",
        width: "17.5%",
        height: "3.2%",
        top: "78.2%",
        left: "18.6%",
      },
    ],
  },
  {
    slug: "/usecases/4/1",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_04_02.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_04_02_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/usecases/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/usecases/4/2",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_04_03.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_04_03_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/usecases/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/usecases/4/3",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_04_06.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_04_06_loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/usecases/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/usecases/4/4",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_04_05.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_04_05_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/usecases/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/usecases/4/5",
    bgImage: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/05_Usecases/05_DAIF_UseCase_04_04.mp4'),
    videoBgLoop: require('../assets/05_Usecases/05_DAIF_UseCase_04_04_Loop.mp4'),
    bgImage2: require('../assets/05_Usecases/DAIF_UseCase_Screen4_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/usecasesb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/usecases/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  
]